// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const loginWithEmailPassword = async (data: any) => {
  try {
    return await http.postLogin<any>('/v1/login', data);
  } catch (error) {
    console.log('loginWithEmailPassword ', error);
  }
};

export const recoverPassword = async (email: string, recaptchaToken?: string) => {
  try {
    return await http.postLogin<any>('/v1/login/recover-email', {
      email,
      app: 'qihotels',
      recaptchaToken,
    });
  } catch (error) {
    console.log('recoverPassword ', error);
  }
};

export const resetPassword = async (data: any) => {
  try {
    return await http.postLogin<any>('/v1/login/reset-password', data);
  } catch (error) {
    console.log('resetPassword ', error);
  }
};
